import axios from "axios";
import { URLS } from "../../../Utils/App_urls";

export const getAllNotificationUser = async (limit = null, page = null) => {
    try {
        const response = await axios.get(`${URLS.getNotificationUser}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            },
            params: {
                limit,
                page,
            },
        });
        return response?.data?.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

let intervalId;

const startFetchingNotifications = () => {
    intervalId = setInterval(async () => {
        await getAllNotificationUser();
    }, 10000);  // Fetch notifications every 10 seconds instead of 1 second
};

const stopFetchingNotifications = () => {
    clearInterval(intervalId);
};

// startFetchingNotifications();

export const markAsReadNotificationUser = async (id = '') => {
    axios.patch(`${URLS.readNotificationUser}/${id}`, { "status": "read" }, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        },
    })
        .then((res) => { })
        .catch((err) => console.error(err))
};

export const markAllAsReadUser = (setNotificationLoader) => {
    setNotificationLoader(true)
    axios.patch(`${URLS?.readAllNotificationsUser}`, { "status": "read" }, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        }
    })
        .then((res) => {
            getAllNotificationUser()
            return res
        })
        .catch((err) => console.error(err))
        .finally(() => setNotificationLoader(false))
}

export const markReadAndRefreshNotificationsUser = async (id, limit = 5, page = 1) => {
    try {
        await markAsReadNotificationUser(id);

        const notifications = await getAllNotificationUser(limit, page);

        return notifications;

    } catch (error) {
        throw error;
    }
};
